import { useEffect } from "react";
import Typed from "typed.js";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
export default function Hero() {
  useEffect(() => {
    AOS.init({ once: true, duration: 800 });

    const typed = new Typed("#typed", {
      strings: [
        "Custom .NET solutions with clean architecture",
        "Fast web & e-commerce platforms",
        "ERP, POS & Inventory Systems",
        "AI & Cloud-ready software",
      ],
      typeSpeed: 45,
      backSpeed: 25,
      loop: true,
    });

    return () => typed.destroy();
  }, []);

  return (
    <>
      <header className="hero text-center text-dark position-relative my-7">
        <div className="gradient-wave"></div>
        <canvas id="particles"></canvas>

        <div
          className="hero-img position-absolute top-0 end-0 h-100 d-none d-lg-block"
          data-aos="zoom-out"
          data-aos-delay="200"
          style={{ zIndex: 0, opacity: 0.25, filter: "brightness(0.8)" }}
        >
          <img
            src={process.env.PUBLIC_URL + "/assets/img/hero-img.png"}
            loading="lazy"
            className="img-fluid h-100"
            alt="MZR Software Solutions Hero"
          />
        </div>

        <div className="container position-relative py-5" style={{ zIndex: 1 }}>
          <div className="mb-3" data-aos="fade-down" data-aos-delay="50">
            <span className="badge rounded-pill text-bg-dark border border-light-subtle px-3 py-2">
              Build. Launch. Scale.
            </span>
          </div>

          <h1 className="display-4 fw-bold" data-aos="fade-up">
            Enterprise-grade software for ambitious teams
          </h1>

          <p
            className="lead text-dark-50 mt-3"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <span id="typed"></span>
          </p>

          <div
            className="d-flex justify-content-center gap-3 mt-4"
            data-aos="zoom-in"
            data-aos-delay="150"
          >
            <Link to="/contact" className="btn btn-brand btn-pill">
              <i className="bi bi-rocket-takeoff me-2"></i>
              Get a Quote
            </Link>
            <Link to="/portfolio" className="btn btn-outline-light btn-pill">
              <i className="bi bi-grid-3x3-gap me-2"></i>
              See Work
            </Link>
          </div>

          <div className="row g-3 mt-5">
            <div className="col-4 kpi" data-aos="fade-up">
              <div className="num">350+</div>
              <div className="text-dark-50">Projects</div>
            </div>
            <div className="col-4 kpi" data-aos="fade-up" data-aos-delay="80">
              <div className="num">200+</div>
              <div className="text-dark-50">Clients</div>
            </div>
            <div className="col-4 kpi" data-aos="fade-up" data-aos-delay="160">
              <div className="num">8+</div>
              <div className="text-dark-50">Years</div>
            </div>
          </div>
        </div>
      </header>

      <section id="mzr-inventory-erp" className="section">
        <div className="container">
          <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap gap-2">
            <h2 className="section-title h1 fw-bold m-0" data-aos="fade-right">
              <i className="bi bi-box-seam me-2"></i>Why Choose{" "}
              <strong>MZR Inventory ERP?</strong>
            </h2>
          </div>

          <p className="text-dark-50 mb-5" data-aos="fade-up">
            MZR Inventory ERP is designed to streamline your business processes
            by integrating essential features like Inventory Management,
            Restaurant Management, and Accounting into a single system. It is a
            complete solution for businesses in retail, restaurants, and service
            industries.
          </p>

          <div className="row g-4 align-items-center">
            <div className="col-md-7" data-aos="fade-right">
              <div className="card-soft h-100 p-4">
                <h5 className="fw-bold mb-3">
                  Inventory Management System with POS
                </h5>
                <p className="text-dark-50 mb-4">
                  Our Inventory Management System is tightly integrated with the
                  POS system, allowing businesses to track inventory in
                  real-time. Whether it’s a retail shop or a large warehouse,
                  manage stock levels, control pricing, and monitor sales
                  seamlessly with MZR Software.
                </p>

                <h5 className="fw-bold mb-3">Restaurant Management System</h5>
                <p className="text-dark-50 mb-4">
                  MZR Software simplifies restaurant management by integrating
                  POS with features like order management, ingredient tracking,
                  recipe-based costing, and real-time sales reporting. This
                  helps restaurants deliver excellent customer service and
                  optimize their operations.
                </p>

                <h5 className="fw-bold mb-3">Accounting System</h5>
                <p className="text-dark-50 mb-4">
                  Our accounting module ensures that every sale, purchase, and
                  expense is tracked in real-time, providing you with accurate
                  financial insights. It supports cash and credit payments,
                  journal entries, and customizable reports, making it ideal for
                  businesses of all sizes.
                </p>

                <a
                  href="https://mzrsoftware.com/erp_plan.html"
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-outline-light btn-sm"
                >
                  See Plan <i className="bi bi-arrow-right ms-1"></i>
                </a>
              </div>
            </div>

            <div className="col-md-5" data-aos="fade-left">
              <img
                src="https://mzrsoftware.com/img/mzr_dashboard.png"
                className="img-fluid rounded"
                alt="MZR Inventory Management System"
                style={{ maxHeight: 400, objectFit: "cover", width: "100%" }}
              />
            </div>
          </div>
        </div>
      </section>

      <section
        id="restaurant-pos-erp"
        className="section"
        style={{ background: "#f56e0b78", padding: "60px 0" }}
      >
        <div className="container">
          <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap gap-2">
            <h2 className="section-title h1 fw-bold m-0" data-aos="fade-right">
              <i className="bi bi-shop-window me-2"></i>MZR Restaurant &
              Inventory ERP
            </h2>
          </div>

          <p className="text-dark-50 mb-5" data-aos="fade-up">
            Simplify and supercharge your restaurant and retail operations with{" "}
            <strong>MZR ERP</strong>. Our all-in-one system combines powerful
            inventory control, seamless restaurant POS, and accurate accounting
            — designed to meet the unique needs of your business. Manage orders
            effortlessly, track ingredients and recipes, and get real-time sales
            insights to optimize your profits.
          </p>

          <div className="row g-4 align-items-center">
            <div className="col-md-5" data-aos="fade-right">
              <img
                src="https://mzrsoftware.com/img/restaurant_pos.png"
                className="img-fluid rounded"
                alt="MZR Restaurant POS"
                style={{ maxHeight: 300, objectFit: "cover", width: "100%" }}
              />
            </div>
            <div className="col-md-7" data-aos="fade-left">
              <div className="card-soft h-100 p-4">
                <h5 className="fw-bold mb-3">
                  Complete Restaurant & Inventory ERP
                </h5>
                <p className="text-dark-50 mb-4">
                  Experience smooth workflows, faster transactions, and detailed
                  financial reporting — all in one easy-to-use platform that
                  puts you in full control. Scales from a small café to
                  multi-location restaurants.
                </p>
                <a
                  href="https://mzrsoftware.com/erp_plan.html"
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-outline-light btn-sm"
                >
                  See Plan <i className="bi bi-arrow-right ms-1"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
